import HttpRequest from "@/api/axios";
const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);
import moment    from 'moment'

export default {
    getBanners(data) {
        return axios.request({
            url: "match/banners",
            method: "get",
            params:data
        });
    },
    getMatchList(data) {
        return axios.request({
            url: "match/index",
            method: "get",
            params:data
        }).then(res=>{
            if(res.status === 200) {
                let system = res.sys_time
                res.data.list.forEach(item=>{
                    item.starttime = item.start_time?moment(item.start_time*1000).format("YYYY/MM/DD"):'';
                    item.reg_starttime = item.reg_start_time?moment(item.reg_start_time*1000).format("YYYY/MM/DD"):'';
                    item.reg_endtime = item.reg_end_time?moment(item.reg_end_time*1000).format("MM/DD"):'';
                    item.endtime = item.end_time?moment(item.end_time*1000).format("MM/DD"):'';
                    if(!item.reg_start_time && !item.reg_end_time) {
                        if(!item.start_time && !item.end_time) {
                            item.statename = '比赛已结束'
                            item.statecolor = '#646464'
                            item.gotitle = '查看详情'
                        } else if(system<item.start_time*1) {
                            item.statename = '比赛未开始'
                            item.statecolor = '#646464'
                            item.gotitle = '查看详情'
                        } else if(system>item.end_time*1){
                            item.statename = '比赛已结束'
                            item.statecolor = '#646464'
                            item.gotitle = '查看详情'
                        } else {
                            item.statename = '比赛未开始'
                            item.statecolor = '#646464'
                            item.gotitle = '查看详情'
                        }
                        
                    } else if(system>=item.reg_start_time*1 && system<= item.reg_end_time*1) {
                        item.statename = '报名中'
                        item.statecolor = '#F7B500'
                        item.gotitle = '去报名'
                    } else if(system>=item.start_time*1 && system<= item.end_time*1) {
                        item.statename = '比赛中'
                        item.statecolor = '#F7B500'
                        item.gotitle = '查看详情'
                    } else if(system<item.reg_start_time*1) {
                        item.statename = '报名未开始'
                        item.statecolor = '#646464'
                        item.gotitle = '查看详情'
                    } else if(system>item.end_time*1){
                        item.statename = '比赛已结束'
                        item.statecolor = '#646464'
                        item.gotitle = '查看详情'
                    } else {
                        item.statename = '等待开赛'
                        item.statecolor = '#646464'
                        item.gotitle = '查看详情'
                    }
                })
            }
            return res;
            
        });
    },
    getMetals(data) {
        return axios.request({
            url: "olympic/metals",
            method: "get",
            params:data
        });
    },
    ossSignature(params){
        return axios.request({
            url: "api/oss-signature",
            method: "get",
            params,
            baseURL:process.env.VUE_APP_API_BASE_URL_MDC
        });
    },
    getLinks(data) {
        return axios.request({
            url: `externallink-config/${data.id}`,
            method: "get",
            params:data,
            baseURL:process.env.VUE_APP_API_BASE_URL2
        });
    },
    getNews(data) {
        return axios.request({
            url: "match/news",
            method: "get",
            params:data
        });
    },
    newsDetail(data){
        return axios.request({
            url: `news/${data.id}`,
            method: "get",
            params:data,
            baseURL:process.env.VUE_APP_API_BASE_URL2
        })
    },
}
